import { render } from "./CompanyNews.vue?vue&type=template&id=7896c888&scoped=true"
import script from "./CompanyNews.vue?vue&type=script&lang=js"
export * from "./CompanyNews.vue?vue&type=script&lang=js"

import "./CompanyNews.vue?vue&type=style&index=0&id=7896c888&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7896c888"]])

export default __exports__